module.exports = __webpack_public_path__ + "static/media/Facebook-icon-small.081fc67f.png";